import { ToastContainer as RTToastContainer } from "react-toastify";

export default function ToastContainer() {
  return (
    <RTToastContainer
      position="top-right"
      autoClose={4000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      theme="colored"
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      limit={1}
    />
  );
}
